import { combineEpics } from 'redux-observable';

import updateFormEpic from './updateForm.epic';
import verifyPhoneEpic from './verifyPhone.epic';
import changePhoneEpic from './changePhone.epic';

export default combineEpics(updateFormEpic, verifyPhoneEpic, changePhoneEpic);
